import { useEffect } from 'react';
import { useLocation } from 'react-router';

import {
  trackProductEvent,
  type AnalyticsEventName,
  type AnalyticsProperties,
  type AnalyticsRouteKey,
} from './track';

const PAGE_VIEW_EVENT_BY_ROUTE: Record<AnalyticsRouteKey, AnalyticsEventName> = {
  landing: 'landing_view',
  public_knowledge: 'public_knowledge_view',
  blog_index: 'blog_index_view',
  blog_article: 'blog_article_view',
  demo: 'demo_view',
  login: 'login_view',
  studio_list: 'studio_list_view',
  studio_room: 'studio_room_view',
  share: 'share_view',
  guitar_play: 'guitar_play_view',
  practice_song: 'practice_song_view',
  practice_room: 'practice_room_open',
};

const sentNavigationKeys = new Set<string>();

function resolveEventName(routeKey: AnalyticsRouteKey) {
  return PAGE_VIEW_EVENT_BY_ROUTE[routeKey];
}

export function resetTrackedPageViewsForTests(): void {
  sentNavigationKeys.clear();
}

export function usePageAnalytics(
  routeKey: AnalyticsRouteKey,
  options?: {
    enabled?: boolean;
    eventName?: AnalyticsEventName;
    properties?: AnalyticsProperties;
  },
) {
  const location = useLocation();
  const enabled = options?.enabled ?? true;
  const eventName = options?.eventName ?? resolveEventName(routeKey);

  useEffect(() => {
    if (!enabled) return;
    const navigationKey = `${location.key}:${routeKey}:${location.pathname}`;
    if (sentNavigationKeys.has(navigationKey)) {
      return;
    }
    sentNavigationKeys.add(navigationKey);
    trackProductEvent(eventName, options?.properties, routeKey);
  }, [
    enabled,
    eventName,
    location.key,
    location.pathname,
    options?.properties,
    routeKey,
  ]);
}
